// extracted by mini-css-extract-plugin
module.exports = {"wx5mbn2":"wx5mbn2","vaxan3q":"vaxan3q"};